export const DATASET_IDS = {
  EMAIL_CONFIGURATIONS: 'emailConfigurations', // From spec: emailConfigurations dataset (ID: 184)
  ACCOUNT_EMAIL_CONFIGURATIONS: 'accountEmailConfigurations', // New dataset for account-specific configurations
  CUSTOMER_SEARCH: 'customerSearch', // Dataset for searching customers
  ACCOUNT_EMAIL_CONFIG: 'accountEmailConfiguration' // Entity for CRUD operations
}

export const EMAIL_PROVIDERS = [
  { value: 'sendgrid', label: 'SendGrid' },
  { value: 'mailgun', label: 'Mailgun' },
  { value: 'ses', label: 'Amazon SES' },
  { value: 'mailchimp', label: 'Mailchimp' },
  { value: 'constant_contact', label: 'Constant Contact' }
]

export const MESSAGES = {
  SEARCH_PLACEHOLDER: 'Search by company name, email, or account ID...',
  NO_CUSTOMER_SELECTED: 'Please search and select a customer to view their email configurations.',
  NO_CONFIGURATIONS: 'No email configurations found for this customer.',
  CONFIRM_DELETE: 'Are you sure you want to delete this email configuration?',
  CONFIRM_SET_PRIMARY: 'Are you sure you want to set this configuration as primary? This will make the current primary configuration secondary.',
  SUCCESS_PRIMARY_SET: 'Email configuration set as primary successfully.',
  SUCCESS_CONFIGURATION_ADDED: 'Email configuration added successfully.',
  SUCCESS_CONFIGURATION_UPDATED: 'Email configuration updated successfully.',
  SUCCESS_CONFIGURATION_DELETED: 'Email configuration deleted successfully.',
  ERROR_LOADING_CONFIGURATIONS: 'Failed to load email configurations.',
  ERROR_SAVING_CONFIGURATION: 'Failed to save email configuration.',
  ERROR_DELETING_CONFIGURATION: 'Failed to delete email configuration.',
  ERROR_SETTING_PRIMARY: 'Failed to set primary configuration.'
}

export const VALIDATION_RULES = {
  DISPLAY_NAME_MIN_LENGTH: 3,
  DISPLAY_NAME_MAX_LENGTH: 255,
  REQUIRED_FIELDS: ['display_name', 'sender']
}